import axios from "axios";
import Cookies from "js-cookie";
import store from "../controller/baseController";
import Enums from "../enums/enums";
import { AddAccessTokenCache } from "../helper/cacheHelper";
import shareHelper from "../helper/shareHelper";
import { ClearAllCacheFromIndexedDB } from "../IndexedDB/CacheIndexedDB";
import * as api from "../service/ApiSevice";

const peakDomain = process.env.VUE_APP_PeakDomain;

function GetAccessToken() {
  return Cookies.get("access_token");
}

function GetRefreshToken() {
  return Cookies.get("refresh_token");
}

function GetKeepLogin() {
  return Cookies.get("keepLogin");
}

function SetCookiesAccessToken(accessToken) {
  if (accessToken) {
    if (shareHelper.IsSetCookiesInDomain()) {
      Cookies.set("access_token", accessToken, { domain: peakDomain });
    } else {
      Cookies.set("access_token", accessToken);
    }
  }
}

function SetCookiesRefreshToken(refreshToken, keepLogin) {
  if (refreshToken) {
    if (shareHelper.IsSetCookiesInDomain()) {
      if (keepLogin) {
        Cookies.set("refresh_token", refreshToken, { expires: 30, domain: peakDomain });
      } else {
        Cookies.set("refresh_token", refreshToken, { domain: peakDomain });
      }
    } else {
      if (keepLogin) {
        Cookies.set("refresh_token", refreshToken, { expires: 30 });
      } else {
        Cookies.set("refresh_token", refreshToken);
      }
    }
  }
}

function MerchantId() {
  let sessionMerchantId = sessionStorage.getItem("emi");
  sessionMerchantId = sessionMerchantId ? sessionMerchantId.PeakDecryption() : null;
  return sessionMerchantId;
}

export default {
  UserId() {
    return parseInt(store.getters.getUserModel ? store.getters.getUserModel.userId : 0);
  },
  Password() {
    let getLocal = localStorage.getItem("userInfo");
    getLocal = JSON.parse(getLocal);
    if (getLocal !== null) {
      return getLocal.userModel.password !== null ? getLocal.userModel.password : "";
    } else {
      return "";
    }
  },
  MerchantId() {
    return MerchantId();
  },
  UserName() {
    let getLocalStorage = localStorage.getItem("userInfo");
    getLocalStorage = JSON.parse(getLocalStorage);
    if (getLocalStorage !== null) {
      return getLocalStorage.userModel.userName;
    } else {
      return "";
    }
  },
  GetRefreshToken() {
    return GetRefreshToken();
  },
  GetAccessToken() {
    return GetAccessToken();
  },
  SetCookiesAccessToken(accessToken) {
    SetCookiesAccessToken(accessToken);
  },
  SetCookiesRefreshToken(refreshToken, keepLogin = false) {
    SetCookiesRefreshToken(refreshToken, keepLogin);
  },
  RemoveCookiesToken() {
    if (shareHelper.IsSetCookiesInDomain()) {
      Cookies.remove("access_token", { domain: peakDomain });
      Cookies.remove("refresh_token", { domain: peakDomain });
      Cookies.remove("access_token");
      Cookies.remove("refresh_token");
    } else {
      Cookies.remove("access_token");
      Cookies.remove("refresh_token");
    }
  },
  GetKeepLogin() {
    return GetKeepLogin();
  },
  SetCookiesKeepLogin() {
    if (shareHelper.IsSetCookiesInDomain()) {
      Cookies.set("keepLogin", true, { expires: 30, domain: peakDomain });
    } else {
      Cookies.set("keepLogin", true, { expires: 30 });
    }
  },
  RemoveCookiesKeepLogin() {
    if (shareHelper.IsSetCookiesInDomain()) {
      Cookies.remove("keepLogin", { domain: peakDomain });
    } else {
      Cookies.remove("keepLogin");
    }
  },
  SetHeaderService(defaultSourceTypeProject = Enums.SourceTypeProject.PeakExperience) {
    const headerService = {
      headers: {
        source: defaultSourceTypeProject,
      },
    };

    return headerService;
  },
  CatchAPIService(errResponse) {
    if (errResponse.status !== 401) {
      return errResponse;
    }
    return api.UserService.DoGetNewAccessTokenByRefreshToken()
      .then(async (resNewAccessTokenByRefreshToken) => {
        if (resNewAccessTokenByRefreshToken.status.IsSuccess()) {
          const keepLogin = GetKeepLogin();
          await ClearAllCacheFromIndexedDB();
          await AddAccessTokenCache(resNewAccessTokenByRefreshToken.data.access_token);
          SetCookiesAccessToken(resNewAccessTokenByRefreshToken.data.access_token);
          SetCookiesRefreshToken(resNewAccessTokenByRefreshToken.data.refresh_token, keepLogin);
          errResponse.config.headers["Authorization"] = "Bearer " + resNewAccessTokenByRefreshToken.data.access_token;
          return axios(errResponse.config)
            .then((resCallback) => {
              return resCallback;
            })
            .catch((errCallback) => {
              location.href = `${window.location.origin}/SessionExpire`;
            });
        } else {
          location.href = `${window.location.origin}/SessionExpire`;
        }
      })
      .catch((error) => {
        location.href = `${window.location.origin}/SessionExpire`;
      });
  },
  GetTimezoneOffset() {
    const date = new Date().getTimezoneOffset();
    const timezoneOffset = (date * -1) / 60;
    return timezoneOffset;
  },
};
